/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxcatalog_Columns_Prepurchase2Inputs */

const en_us2_sandboxcatalog_columns_prepurchase2 = /** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-purchase`)
};

const es_es2_sandboxcatalog_columns_prepurchase2 = /** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precompra`)
};

const ru_sandboxcatalog_columns_prepurchase2 = /** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предзаказ`)
};

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const id_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const ms_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const da_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const de_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const es_mx2_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const fil_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const fr_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const it_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const hu_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const nl_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const no_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const pl_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const pt_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const pt_br2_sandboxcatalog_columns_prepurchase2 = pt_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const ro_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const fi_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const sv_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const vi_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const tr_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const cs_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const bg_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const uk_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const ar_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const hi_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const th_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const ja_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const zh_cn2_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const zh_hant1_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/** @type {(inputs: Sandboxcatalog_Columns_Prepurchase2Inputs) => LocalizedString} */
const ko_sandboxcatalog_columns_prepurchase2 = en_us2_sandboxcatalog_columns_prepurchase2;

/**
* | output |
* | --- |
* | "Pre-purchase" |
*
* @param {Sandboxcatalog_Columns_Prepurchase2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxcatalog_columns_prepurchase2 = /** @type {((inputs?: Sandboxcatalog_Columns_Prepurchase2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxcatalog_Columns_Prepurchase2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "ms") return ms_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "da") return da_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "de") return de_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "en-US") return en_us2_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "es-ES") return es_es2_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "fil") return fil_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "fr") return fr_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "it") return it_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "hu") return hu_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "nl") return nl_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "no") return no_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "pl") return pl_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "pt") return pt_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "ro") return ro_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "fi") return fi_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "sv") return sv_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "vi") return vi_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "tr") return tr_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "cs") return cs_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "bg") return bg_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "ru") return ru_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "uk") return uk_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "ar") return ar_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "hi") return hi_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "th") return th_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "ja") return ja_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxcatalog_columns_prepurchase2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxcatalog_columns_prepurchase2(inputs)
	return ko_sandboxcatalog_columns_prepurchase2(inputs)
});
export { sandboxcatalog_columns_prepurchase2 as "sandboxCatalog.columns.prePurchase" }